import * as React from 'react';
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import './BoxPresentation.scss';

const BoxPresentation =  () => (
<Row className="section-title" type="flex" align="middle" justify="center">
<Col>
    <div className="logo" />
    <h1>Iniciar sesión en Puerto Angamos Copper Tracker</h1>
</Col>
</Row>
);

export default BoxPresentation;
